import { assertNever, CheckedAddress } from '@sparkdotfi/common-universal'

import { SwapObjective } from '../types'
import { getSwapActionPath } from './getSwapActionPath'
import {
  dssLitePsmConfig,
  migrationActionsConfig,
  psm3Address,
  usdsPsmWrapperConfig,
} from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getApproveActions } from '@/features/actions/logic/getApproveActions'
import { Action, ActionContext } from '@/features/actions/logic/types'

export function createSwapActions(objective: SwapObjective, context: ActionContext): Action[] {
  const { chainId } = context

  const actionPath = getSwapActionPath({
    from: objective.from,
    to: objective.to,
    chainId,
  })

  function getSpenderApproveActions(spender: CheckedAddress): Action[] {
    return getApproveActions({
      token: objective.from,
      value: objective.amount,
      spender,
      context,
    })
  }

  switch (actionPath) {
    case 'dai-usdc':
    case 'usdc-dai':
      return [
        ...getSpenderApproveActions(getContractAddress(dssLitePsmConfig.address, chainId)),
        createSwapAction(objective),
      ]

    case 'usdc-usds':
    case 'usds-usdc':
      return [
        ...getSpenderApproveActions(getContractAddress(usdsPsmWrapperConfig.address, chainId)),
        createSwapAction(objective),
      ]

    case 'base-usdc-usds':
    case 'base-usds-usdc':
    case 'arbitrum-usdc-usds':
    case 'arbitrum-usds-usdc':
    case 'optimism-usdc-usds':
    case 'optimism-usds-usdc':
    case 'unichain-usdc-usds':
    case 'unichain-usds-usdc':
      return [...getSpenderApproveActions(getContractAddress(psm3Address, chainId)), createSwapAction(objective)]

    case 'dai-usds':
    case 'usds-dai':
      return [
        ...getSpenderApproveActions(getContractAddress(migrationActionsConfig.address, chainId)),
        createSwapAction(objective),
      ]

    default:
      assertNever(actionPath)
  }
}

function createSwapAction(objective: SwapObjective): Action {
  return {
    type: 'swap',
    from: objective.from,
    to: objective.to,
    amount: objective.amount,
  }
}
